export class RequestVenueFacility {
  id: number;
  requestVenueId: number;
  venueFacilityTypeId: number;
  name: string;
  isChargable: boolean;
  charge: number;
}



// WEBPACK FOOTER //
// ./src/app/core/models/request-venue-facility.ts